module.exports = __webpack_public_path__ + "assets/img/td7.96b960fe.png";